import { Heart } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-blue-900 text-white py-12" data-testid="footer">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3
              className="text-2xl font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Banner of Grace
            </h3>
            <p
              className="text-blue-200 text-sm leading-relaxed"
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              A Non-Profit Christian Gospel Ministry dedicated to spreading the love of Christ and transforming lives through faith and service.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4
              className="text-xl font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2 text-blue-200 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>
              <li>
                <button
                  onClick={() => document.getElementById("about").scrollIntoView({ behavior: "smooth" })}
                  className="hover:text-amber-400 transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("programs").scrollIntoView({ behavior: "smooth" })}
                  className="hover:text-amber-400 transition-colors"
                >
                  Our Programs
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("events").scrollIntoView({ behavior: "smooth" })}
                  className="hover:text-amber-400 transition-colors"
                >
                  Events
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("donate").scrollIntoView({ behavior: "smooth" })}
                  className="hover:text-amber-400 transition-colors"
                >
                  Donate
                </button>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4
              className="text-xl font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Contact Us
            </h4>
            <div className="space-y-2 text-blue-200 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>
              <p>Waec Junction, Plot 3 Aguleri Street</p>
              <p>Independence Layout, Enugu</p>
              <p>Abuja, Enugu</p>
              <p className="mt-3">
                <a href="mailto:contacts@bannerofgraceministry.org" className="hover:text-amber-400 transition-colors">
                  contacts@bannerofgraceministry.org
                </a>
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-blue-800 pt-8 text-center">
          <p className="text-blue-200 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>
            © 2025 Banner of Grace Salvation International Gospel Ministry. All rights reserved.
          </p>
          <p className="text-blue-300 text-xs mt-2" style={{ fontFamily: "'Crimson Text', serif" }}>
            Registered Non-Profit Christian Organization
          </p>
          <p className="text-amber-400 text-xs mt-1 font-semibold" style={{ fontFamily: "'Crimson Text', serif" }}>
            CAC/IT/NO 8553783
          </p>
        </div>
      </div>
    </footer>
  );
};